// Should stay in sync with mddap-functions\prisma\enums\eventObservationType.mjs

export const EVENT_OBSERVATION_TYPE = {
  ATM: 0,
  ATL: 1
};
